"use client";
import React from "react";
import arrowRight from "@/assets/icons/chevronRight.svg";

import Image from "next/image";

export default function EventDetailsCard({ data, color }: any) {
  return (
    <div
      style={{
        borderColor: `${color}66`,
        boxShadow: `0px 0px 12px 0px ${color}33`,
      }}
      className="w-full lg:w-3/4 mx-auto glass-effect border border-[#d9ac4f66] rounded-[20px]  px-6 py-[10px] lg:p-4 lg:mb-6 flex flex-col lg:gap-2"
    >
      <div className="flex items-center justify-between gap-2 text-[#D1D3D4] cursor-pointer">
        <div className="text-[18px] lg:text-[22px] text-[#D1D3D4] font-medium lg:font-bold">
          {data?.name}
        </div>
        <Image
          src={arrowRight}
          alt="Arrow Icon"
          className="w-2 lg:w-3 h-auto"
          onClick={() => window.history.back()}
        />
      </div>
      <div className="flex gap-5 lg:gap-12 text-[12px] lg:text-[18px] font-medium text-[#D1D3D4] mt-2 text-nowrap">
        <p className="flex items-start gap-1 lg:gap-2">
          <svg
            width="13"
            height="18"
            viewBox="0 0 17 19"
            fill={color || "#d9ac4f"}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 6.6837C0 4.89711 -4.93775e-08 4.00476 0.485452 3.44964C0.970904 2.89453 1.75127 2.89453 3.31367 2.89453H13.2547C14.8171 2.89453 15.5974 2.89453 16.0829 3.44964C16.5683 4.00476 16.5683 4.89711 16.5683 6.6837C16.5683 7.12987 16.5683 7.35343 16.4474 7.49268C16.3256 7.63099 16.1293 7.63099 15.7399 7.63099H0.828416C0.438232 7.63099 0.242726 7.63099 0.120949 7.49268C-7.40662e-08 7.35343 0 7.12892 0 6.6837Z"
              fill={color || "#d9ac4f"}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 15.2111C0 16.9977 -4.93775e-08 17.89 0.485452 18.4451C0.970904 19.0003 1.75127 19.0003 3.31367 19.0003H13.2547C14.8171 19.0003 15.5974 19.0003 16.0829 18.4451C16.5683 17.89 16.5683 16.9977 16.5683 15.2111V10.4746C16.5683 10.0285 16.5683 9.8049 16.4474 9.66565C16.3256 9.52734 16.1293 9.52734 15.7399 9.52734H0.828416C0.438232 9.52734 0.242726 9.52734 0.120949 9.66565C-7.40662e-08 9.8049 0 10.0294 0 10.4746V15.2111ZM4.14208 12.3692C4.14208 11.923 4.14208 11.6995 4.26303 11.5602C4.38481 11.4219 4.58114 11.4219 4.9705 11.4219H6.62733C7.01751 11.4219 7.21302 11.4219 7.3348 11.5602C7.45575 11.6995 7.45575 11.923 7.45575 12.3692C7.45575 12.8154 7.45575 13.039 7.3348 13.1782C7.21302 13.3165 7.01669 13.3165 6.62733 13.3165H4.9705C4.58031 13.3165 4.38481 13.3165 4.26303 13.1782C4.14208 13.039 4.14208 12.8144 4.14208 12.3692ZM4.26303 15.3494C4.14208 15.4886 4.14208 15.7132 4.14208 16.1584C4.14208 16.6036 4.14208 16.8281 4.26303 16.9674C4.38481 17.1057 4.58114 17.1057 4.9705 17.1057H6.62733C7.01751 17.1057 7.21302 17.1057 7.3348 16.9674C7.45575 16.8281 7.45575 16.6036 7.45575 16.1584C7.45575 15.7132 7.45575 15.4886 7.3348 15.3494C7.21302 15.2111 7.01669 15.2111 6.62733 15.2111H4.9705C4.58031 15.2111 4.38481 15.2111 4.26303 15.3494ZM9.11258 12.3692C9.11258 11.923 9.11258 11.6995 9.23353 11.5602C9.35531 11.4219 9.55164 11.4219 9.941 11.4219H11.5978C11.988 11.4219 12.1835 11.4219 12.3053 11.5602C12.4262 11.6995 12.4262 11.923 12.4262 12.3692C12.4262 12.8154 12.4262 13.039 12.3053 13.1782C12.1835 13.3165 11.9872 13.3165 11.5978 13.3165H9.941C9.55081 13.3165 9.35531 13.3165 9.23353 13.1782C9.11258 13.039 9.11258 12.8144 9.11258 12.3692ZM9.23353 15.3494C9.11258 15.4886 9.11258 15.7132 9.11258 16.1584C9.11258 16.6036 9.11258 16.8281 9.23353 16.9674C9.35531 17.1057 9.55081 17.1057 9.941 17.1057H11.5978C11.988 17.1057 12.1835 17.1057 12.3053 16.9674C12.4262 16.8281 12.4262 16.6036 12.4262 16.1584C12.4262 15.7132 12.4262 15.4886 12.3053 15.3494C12.1835 15.2111 11.9872 15.2111 11.5978 15.2111H9.941C9.55081 15.2111 9.35531 15.2111 9.23353 15.3494Z"
              fill={color || "#d9ac4f"}
            />
            <path
              d="M4.14258 1V3.84187M12.4267 1V3.84187"
              stroke={color || "#d9ac4f"}
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>

          <span>{data?.from_date}</span>
        </p>
        <div className="flex items-start gap-1 lg:gap-2 w-full truncate">
          <svg
            width="16"
            height="18"
            viewBox="0 0 10 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.26562 0.200195C2.78444 0.200195 0.765625 2.13098 0.765625 4.50332C0.765625 5.6331 1.28059 7.13554 2.29619 8.96901C3.11181 10.4411 4.05541 11.7722 4.54619 12.4346C4.62912 12.5477 4.73755 12.6398 4.86269 12.7032C4.98783 12.7667 5.12616 12.7997 5.26647 12.7997C5.40677 12.7997 5.5451 12.7667 5.67025 12.7032C5.79539 12.6398 5.90382 12.5477 5.98675 12.4346C6.47669 11.7722 7.42113 10.4411 8.23675 8.96901C9.25066 7.1361 9.76562 5.63366 9.76562 4.50332C9.76562 2.13098 7.74681 0.200195 5.26562 0.200195ZM5.26562 6.5002C4.90962 6.5002 4.56161 6.39463 4.2656 6.19684C3.96959 5.99905 3.73888 5.71793 3.60264 5.38903C3.4664 5.06012 3.43076 4.6982 3.50021 4.34903C3.56966 3.99987 3.7411 3.67914 3.99283 3.4274C4.24457 3.17567 4.5653 3.00424 4.91446 2.93478C5.26363 2.86533 5.62555 2.90097 5.95445 3.03721C6.28336 3.17345 6.56448 3.40416 6.76227 3.70017C6.96006 3.99618 7.06562 4.34419 7.06562 4.7002C7.0651 5.17742 6.87529 5.63496 6.53784 5.97241C6.20039 6.30986 5.74285 6.49967 5.26562 6.5002Z"
              fill={color || "#d9ac4f"}
            />
          </svg>

          <span>{data?.full_address}</span>
        </div>
      </div>
    </div>
  );
}
